module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/header_bg_sp-cf18c6576641344d285a4e553b7a3697.png";